{
  "buttons": {
    "manage": "Manage Album",
    "edit": "Edit Album Details",
    "sort": "Sort Photo Order",
    "addPhotos": "Add Photos",
    "quitSort": "Exit",
    "back": "Back to Albums"
  },
  "rotatePhoto": {
    "failure": "Photo rotation failed. Please try again."
  },
  "albumDetails": {
    "uploadFailuresReportButton": "Failed Photo Upload Report"
  },
  "confirmations": {
    "sort": {
      "title": "Change sort order",
      "description": "Replace your custom order with ",
      "buttonConfirmation": "Sort"
    }
  },
  "toastMessages": {
    "scheduleUpdate": {
      "publishNow": "Your album has been published",
      "saveAsDraft": "Your album has been saved as a draft",
      "scheduleForLater": "Your album has been scheduled for"
    }
  },
  "banner": {
    "legacy": "This is a legacy album. Legacy albums do not store the date and time or the filename. Sorting is limited to custom drag and drop.",
    "legacyAlbumLink": "Learn more about legacy albums"
  },
  "details": {
    "constraintsPill": {
      "allAudiences": "Everyone",
      "customAudience": "Custom Audience"
    }
  }
}
